import React from 'react'
import TrustNameAddressChange from './TrustOrSocietyNameChangeApplicationDetails'

export default function TrustSocNameChange() {
    return (
        <div><TrustNameAddressChange /></div>
    )
}
